import ILocation, { IArea, IFacility } from "../../interfaces/ILocation";

const appendToLocationList = "APPEND_TO_LOCATION_LIST";
const appendToFacilityList = "APPEND_TO_FACILITY_LIST";
const appendToAreaList = "APPEND_TO_AREA_LIST";



interface IAppendToLocationList {
    type: typeof appendToLocationList;
    payload: { locations: ILocation[] };
}

interface IAppendToFacilityList {
    type: typeof appendToFacilityList;
    payload: { facilities: IFacility[] };
}

interface IAppendToAreaList {
    type: typeof appendToAreaList;
    payload: { areas: IArea[] };
}



export type ILocationAction
    = IAppendToLocationList
    | IAppendToFacilityList
    | IAppendToAreaList
    ;



export const createAppendToLocationList = (locations: ILocation[]): IAppendToLocationList => ({
    type: appendToLocationList,
    payload: { locations },
});

export const createAppendToFacilityList = (facilities: IFacility[]): IAppendToFacilityList => ({
    type: appendToFacilityList,
    payload: { facilities },
});

export const createAppendToAreaList = (areas: IArea[]): IAppendToAreaList => ({
    type: appendToAreaList,
    payload: { areas },
});



